export const ANALYTICS_TRACK = 'analytics/track';
export const ANALYTICS_TRACK_SUCCESS = 'analytics/track/success';
export const ANALYTICS_TRACK_FAILED = 'analytics/track/failed';
